import { css } from '@emotion/react';
import { justifiInlineStyles, justifiOverrideStyles } from '../global.styles';

export const inlineStyles = (shouldHideRadioListItem: boolean) =>
  css([justifiInlineStyles, shouldHideRadioListItem && hideRadioListItem]).styles.replaceAll(/;;\n?/g, '\n');

export const overrideStyles = css`
  ${justifiOverrideStyles.styles}
  hidden-input {
    display: block;
    height: 0;
    overflow: hidden;
  }

  .row > .align-content-end {
    align-content: flex-start !important;
  }
`.styles;

export const hideRadioListItem = css`
  ::part(radio-list-item) {
    display: none;
  }
`;
